import { useState } from 'react';
import { Callout, DirectionalHint, Link, Text, useTheme } from '@fluentui/react';
import HelpSupport from '../Help/HelpSupport';
import { useAccount } from '@azure/msal-react';

export const UserNotFound = () => {
    const [showHelpCallout, setShowHelpCallout] = useState(false);
    const theme = useTheme();
    const msalUser = useAccount();

    return (
        <div className="centeredtext">
            <Text
                styles={{
                    root: {
                        color: theme.semanticColors.bodyText,
                    },
                }}
                variant="xxLarge"
            >
                User {msalUser.username} not found
            </Text>
            <br />
            <br />
            <details>
                <summary>
                    <Text
                        styles={{
                            root: {
                                color: theme.semanticColors.bodyText,
                            },
                        }}
                        variant="large"
                    >
                        More information
                    </Text>
                </summary>
                <Text
                    styles={{
                        root: {
                            color: theme.semanticColors.bodyText,
                        },
                    }}
                    variant="large"
                >
                    Either your user has not been synchronized into Time for Teams or user auto creation is disabled.
                </Text>
            </details>
            <br />
            <br />
            <Text
                styles={{
                    root: {
                        color: theme.semanticColors.bodyText,
                    },
                }}
                variant="xLarge"
            >
                Please contact your{' '}
                <Link id="showhelpbutton" onClick={() => setShowHelpCallout(s => !s)} styles={{ root: { fontStyle: 'inherit', fontWeight: 600 } }}>
                    PMO Support
                </Link>{' '}
                if you believe this is not correct.
            </Text>
            {showHelpCallout && (
                <Callout
                    // style={{ minWidth: 800, minHeight: 300 }}
                    style={{ width: '100%', maxWidth: 800, minHeight: 200 }}
                    gapSpace={0}
                    target={'#showhelpbutton'}
                    directionalHint={DirectionalHint.rightCenter}
                    onDismiss={() => setShowHelpCallout(false)}
                    setInitialFocus
                >
                    <HelpSupport />
                </Callout>
            )}
        </div>
    );
};
